// src/api/auth.api.js
import axiosClient from "./axiosClient";

export const loginApi = (credentials) => {
  return axiosClient.post("/auth/login", credentials);
};

export const logoutApi = () => {
  return axiosClient.post("/auth/logout");
};

export const getProfileApi = () => {
  return axiosClient.get("/auth/me");
};
